import { MissionData } from '../types';
import { GcpPlacementService, ScheduledFlight, Site } from '../../../../types';
import { UploadState } from '../../../../consts/uploadState';
import { PlacementServiceStatusAirtable } from '../../../../consts/placementServiceStatusAirtable';
import { determineIfScopeIsPanoOnly, determineIfScopeIsScan } from './scope';
import { substrDateFromAirtableFormat } from './date';
import { UploadData } from '../../../../store/uploadStore';

export const isUploadCompleted = (upload: UploadData) =>
  upload.overview.photosCount.uploaded === upload.overview.photosCount.all;

export const determineIsScanMissionCompleted = (site: Site, schedule: ScheduledFlight) =>
  [site.uploads?.ppks ?? [], site.uploads?.scan ?? [], site.uploads?.lidar ?? []]
    .flat()
    .filter(
      ({ flightScheduleId, date }) =>
        flightScheduleId === schedule.airtableRecordId && substrDateFromAirtableFormat(schedule.flightDateIso) === date,
    )
    .some(({ state }) => [UploadState.Loaded, UploadState.Done].includes(state));

export const determineIsPanoMissionCompleted = (site: Site, schedule: ScheduledFlight) =>
  (site.uploads?.pano || [])
    .filter(({ flightScheduleId }) => flightScheduleId === schedule.airtableRecordId)
    .some(({ state }) => [UploadState.Loaded, UploadState.Done].includes(state));

export const determineIsGcpPlacementMissionCompleted = (gcpPlacementService: GcpPlacementService) =>
  gcpPlacementService.status === PlacementServiceStatusAirtable.ToBeProcessedByGis;

export const determineIsMissionCompleted = (mission: MissionData) => {
  const { site, schedule, gcpPlacementService } = mission;

  const isScanOk =
    schedule && determineIfScopeIsScan(schedule.scope) ? determineIsScanMissionCompleted(site, schedule) : true;
  const isPanoOk =
    schedule && site.projectInfo.parsedPanoramaLocations?.length
      ? determineIsPanoMissionCompleted(site, schedule)
      : true;
  const isGcpOk = gcpPlacementService ? determineIsGcpPlacementMissionCompleted(gcpPlacementService) : true;

  // We have to show Video and other unsupported scope missions per Olga's request, but we can't handle their uploads.
  // So we will always show them as uncompleted. The UI will explain this to the pilot.
  if (schedule?.scope && !determineIfScopeIsPanoOnly(schedule.scope) && !determineIfScopeIsScan(schedule.scope)) {
    return false;
  }

  return isScanOk && isPanoOk && isGcpOk;
};
